import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

export default function Programs({ programs = [], onBook }) {
  return (
    <section id="coaching" className="py-16 md:py-24" style={{ background: "var(--ev-surface)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="max-w-2xl">
          <div className="eyebrow">How to work with me</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Two ways to begin your transformation.
          </h2>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {programs.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={HOME.programCard(i)}
              initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.05 }}
              className="ev-card-cream p-7 md:p-10 flex flex-col smooth-hover"
            >
              <div className="eyebrow">{p.cadence}</div>
              <h3 className="font-serif-ev text-3xl md:text-4xl mt-3 leading-tight">{p.title}</h3>
              <p className="mt-4 text-[15px] md:text-base max-w-md" style={{ color: "var(--ev-muted)" }}>
                {p.description}
              </p>
              <div className="mt-6 text-xs uppercase tracking-widest" style={{ color: "var(--ev-blue-2)" }}>
                {p.duration} · {p.modality}
              </div>
              <div className="mt-6">
                <button data-testid={HOME.bookProgramBtn(i)} onClick={() => onBook(p)} className="ev-btn ev-btn-primary">
                  Book this path <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
